<template>
  <div id="app" class="app-wrap">
    <my-header ref="header"></my-header>
    <div class="router-view" :style="`min-height:${minHeight}px`">
      <router-view></router-view>
    </div>
    <my-footer ref="footer" v-if="showFooter"></my-footer>
  </div>
</template>

<script>
import { debounce } from '@/libs/util'

import myHeader from'@/components/header'
import myFooter from'@/components/footer'
import { mapActions } from 'vuex'
export default {
  name: 'App',
  data () {
    return {
      minHeight: 300
    }
  },
  methods: {
    ...mapActions(['updateScreenSize']),
    calcHeight () {
      let maxWidth = document.documentElement.clientWidth || document.body.clientWidth
      let maxHeight = document.documentElement.clientHeight || document.body.clientHeight
      let headerHeight = this.$refs.header.$el.clientHeight
      // let footerHeight = this.showFooter ? this.$refs.footer.$el.clientHeight : 0
      this.minHeight = maxHeight - headerHeight - 100
      this.updateScreenSize({ width: maxWidth, height: maxHeight, routerHeight: this.minHeight })
    }
  },
  computed: {
    showFooter () {
      return this.$route.path.indexOf('reset-password') > -1 || this.$route.path.indexOf('login') > -1
    }
  },
  mounted() {
    this.calcHeight()
    window.addEventListener('load', this.calcHeight)
    window.addEventListener('resize', debounce(() => {
      this.calcHeight()
    }))
  },
  components: {
    myHeader,
    myFooter
  }
}
</script>

<style lang="less">
.app-wrap {
  overflow-x: hidden;
}
.router-view {
  margin-top: 90px;
  // position: relative;
  // 防止margin溢出，计算高度会有误差
  &::before {
    content: '';
    display: table;
  }
}
</style>
